//api/v1/start
//api/v1/stop
//api/v1/status
//api/v1/restart

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export async function startBot() {
    const response = await fetch(`${API_URL}/api/v1/start`, {
        method: 'POST',
        headers: getAuthHeader()
    });
    return response;
}

export async function stopBot() {
    const response = await fetch(`${API_URL}/api/v1/stop`, {
        method: 'POST',
        headers: getAuthHeader()
    });
    return response;
}

export async function getBotStatus() {
    const response = await fetch(`${API_URL}/api/v1/status`, {
        method: 'GET',
        headers: getAuthHeader()
    });
    return response;
}

export async function restartBot() {
    const response = await fetch(`${API_URL}/api/v1/restart`, {
        method: 'POST',
        headers: getAuthHeader()
    });
    return response;
}
